import React from "react";
import FocusedMarketListingPresenter from "./FocusedMarketList.presenter";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { MapStateToProps, MapDispatchToProps, C_Props, MergedProps, C_States } from "./FocusedMarketList.type";
import { FocusedMarketOutputModel, RootState, TCb, LanguageOutputModel } from "../../../../../models";
import { NotificationActions, AllLanguageListActions } from "../../../../../store/actions";
import _ from "lodash";

import { APP_ROUTES, INITIAL_FETCHING_PAGINATION_DATA } from "../../../../../constants";

import { FocusedMarketService } from "../../../../../services";
import { FocusedMarketUtil, loadCallback } from "../../../../../utils";
import { withRouter } from "react-router-dom";

const EMPTY_FILTER: C_States["filter"] = {
  searchValue: "",
};

class FocusedMarketListingContainer extends React.Component<MergedProps, C_States> {
  constructor(props) {
    super(props);
    const focusedMarketPageCode = this.props.match.params.marketCode;

    this.state = {
      filter: EMPTY_FILTER,
      fetchedFocusedMarket: INITIAL_FETCHING_PAGINATION_DATA,
      visibleFocusedMarketCode: focusedMarketPageCode,
      visibleFocusedMarketForm: Boolean(focusedMarketPageCode),

      activeLanguageId: "",
      languageData: [],
      amountPost: 0,
    };
  }

  openFocusedMarketFormModal = (focusedMarketCode?: string) => {
    this.setState({ visibleFocusedMarketCode: focusedMarketCode, visibleFocusedMarketForm: true }, () => {
      if (focusedMarketCode) {
        this.props.history.push(FocusedMarketUtil.buildFocusedMarketDetailPath(focusedMarketCode));
      }
    });
  };

  closeFocusedMarketFormModal = (cb?: TCb) => {
    this.props.history.push(APP_ROUTES.PAGEMANAGEMENT.FOCUSED_MARKET.BASE);
    this.setState({ visibleFocusedMarketCode: undefined, visibleFocusedMarketForm: false }, () => {
      loadCallback(cb?.success);
    });
  };

  countPost = (dataPost: FocusedMarketOutputModel[]) => {
    const data: any = dataPost;
    const uniqueObj = {};
    for (var i = 0; i < data.length; i++) {
      uniqueObj[data[i]] = 1 + (uniqueObj[data[i]] || 0);
    }
    const count = uniqueObj[Object.keys(uniqueObj)[Object.keys(uniqueObj).length - 1]];
    // Khi data = [] => count: undefined
    if (count) {
      this.setState({
        amountPost: count,
      });
    }
  };

  onSearch = _.debounce((searchValue: string) => {
    this.setState(
      (prevState) => {
        return {
          filter: {
            ...prevState.filter,
            searchValue,
          },
        };
      },
      () => {
        this.onApplyFilter(false);
      }
    );
  }, 300);

  onApplyFilter = (loadMore: boolean, cb?: TCb) => {
    if (this.state.fetchedFocusedMarket.loading && loadMore) return;
    this.props.all_language_list.data.forEach((e: LanguageOutputModel) => {
      if (e.isPrimary) {
        this.setState({
          activeLanguageId: e.id,
        });
      }
    });

    this.setState(
      (prevState) => {
        return {
          fetchedFocusedMarket: {
            ...prevState.fetchedFocusedMarket,
            data: loadMore ? prevState.fetchedFocusedMarket.data : [],
            loading: true,
          },
        };
      },
      () => {
        const query: Parameters<typeof FocusedMarketService.getAllFocusedMarketPageByLanguage>[0] = {
          languageId: this.state.activeLanguageId,
        };

        FocusedMarketService.getAllFocusedMarketPageByLanguage(query)
          .then((res) => {
            this.countPost(res.data.data);
            if (res && res.data?.data) {
              this.setState(
                (prevState) => {
                  let focusedMarketPages: FocusedMarketOutputModel[] = [...res.data.data];

                  if (loadMore) {
                    focusedMarketPages.unshift(...prevState.fetchedFocusedMarket.data);
                  }

                  return {
                    fetchedFocusedMarket: {
                      ...res.data,
                      data: focusedMarketPages,
                      loading: false,
                    },
                  };
                },
                () => {
                  loadCallback(cb?.success);
                }
              );
            } else {
              this.setState({
                fetchedFocusedMarket: INITIAL_FETCHING_PAGINATION_DATA,
              });
            }
          })
          .catch((err) => {
            this.setState({
              fetchedFocusedMarket: INITIAL_FETCHING_PAGINATION_DATA,
            });
          });
      }
    );
  };

  onLoadMore = () => {
    this.onApplyFilter(true);
  };

  componentDidMount() {
    if (!this.props.all_language_list.data.length) {
      this.props.actions.getAllLanguages({
        success: () => {
          this.onApplyFilter(false);
        },
      });
    } else {
      this.onApplyFilter(false);
    }
  }

  render() {
    return (
      <FocusedMarketListingPresenter
        {...this.props}
        {...this.state}
        onLoadMore={this.onLoadMore}
        onSearch={this.onSearch}
        openFocusedMarketFormModal={this.openFocusedMarketFormModal}
        closeFocusedMarketFormModal={this.closeFocusedMarketFormModal}
        reloadListingPage={() => {
          this.onApplyFilter(false);
        }}
      />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,
    }),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions, AllLanguageListActions), dispatch),
    })
  )(FocusedMarketListingContainer)
);
